import { Fragment, useState } from 'react'
import { useSelector } from 'react-redux'
import Reversals from './Reversals'
import VendorInitiatedReversals from './VendorInitiatedReversals'
import { ROLE_SLUGS } from '../../utils/auth/permissionConstants'
import useGuidedTour from '../../hooks/useGuidedTour'
import { REVERSALS_PAGE_OVERVIEW_TOUR_ID, buildReversalsPageOverviewTourSteps } from './ReversalsPage.tour'

const TABS = {
    ADMIN_INITIATED:  'admin-initiated',
    VENDOR_INITIATED: 'vendor-initiated',
}

const TAB_META = {
    [TABS.ADMIN_INITIATED]: {
        label:      'Admin initiated',
        helperText: 'Reversals we run end to end. The exec admin starts it here, our system calls Safaricom to pull the money back, and the ledger updates as soon as Safaricom confirms.',
    },
    [TABS.VENDOR_INITIATED]: {
        label:      'Vendor initiated',
        helperText: 'Refunds the vendor already sent back over M-Pesa on their own. Safaricom is done; the exec admin records the incoming payment here so the ledger catches up.',
    },
}

const ReversalsPage = () => {
    const userRole = useSelector((state) => state.auth.authUser?.role_slug)
    const [activeTab, setActiveTab] = useState(TABS.ADMIN_INITIATED)

    useGuidedTour(
        REVERSALS_PAGE_OVERVIEW_TOUR_ID,
        buildReversalsPageOverviewTourSteps(),
        { enabled: userRole === ROLE_SLUGS.EXEC_ADMIN },
    )

    if (userRole !== ROLE_SLUGS.EXEC_ADMIN) {
        return (
            <div className="row">
                <div className="col-12">
                    <div className="card">
                        <div className="card-body text-center py-5">
                            <p className="text-muted mb-0">You do not have permission to view this page.</p>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    const activeMeta = TAB_META[activeTab]

    return (
        <Fragment>
            <div className="row">
                <div className="col-12">
                    <div className="card" data-tour="reversals-page-card">
                        <div className="card-header">
                            <h4 className="card-title mb-0">Reversals</h4>
                        </div>
                        <div className="card-body">
                            <ul className="nav nav-tabs mb-3" role="tablist" data-tour="reversals-tabs">
                                {Object.entries(TAB_META).map(([key, meta]) => (
                                    <li key={key} className="nav-item">
                                        <button
                                            type="button"
                                            className={`nav-link ${activeTab === key ? 'active' : ''}`}
                                            onClick={() => setActiveTab(key)}
                                            role="tab"
                                            aria-selected={activeTab === key}
                                            data-tour={`reversals-tab-${key}`}
                                        >
                                            {meta.label}
                                        </button>
                                    </li>
                                ))}
                            </ul>

                            <p className="text-muted small mb-3">{activeMeta.helperText}</p>

                            {activeTab === TABS.ADMIN_INITIATED && <Reversals />}
                            {activeTab === TABS.VENDOR_INITIATED && <VendorInitiatedReversals />}
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default ReversalsPage
